import { render } from "./CustomerEventsTimeline.vue?vue&type=template&id=608dabc6&scoped=true&ts=true&lang=pug"
import script from "./CustomerEventsTimeline.vue?vue&type=script&lang=ts"
export * from "./CustomerEventsTimeline.vue?vue&type=script&lang=ts"

import "./CustomerEventsTimeline.vue?vue&type=style&index=0&id=608dabc6&lang=scss"
import "./CustomerEventsTimeline.vue?vue&type=style&index=1&id=608dabc6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608dabc6"]])

export default __exports__